import { render, staticRenderFns } from "./ativos-inativos-professores.vue?vue&type=template&id=3bb47b8a&scoped=true&"
import script from "./ativos-inativos-professores.vue?vue&type=script&lang=js&"
export * from "./ativos-inativos-professores.vue?vue&type=script&lang=js&"
import style0 from "./ativos-inativos-professores.vue?vue&type=style&index=0&id=3bb47b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb47b8a",
  null
  
)

export default component.exports